import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import SettingsClient from '../components/SettingsClient'

function SettingsError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load settings.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/settings/')({
  head: () => ({
    meta: [{ title: 'Settings | Unbreakable' }],
  }),
  errorComponent: SettingsError,
  component: SettingsPage,
})

function SettingsPage() {
  return (
    <AuthGuard>
      <SettingsClient initialUser={null} />
    </AuthGuard>
  )
}
